/** Same order as the deck builder's Ordenar button. */

export type DeckCardCategory = 'monster' | 'spell' | 'trap' | 'other'

export interface SortableDeckCard {
  id?: string | number
  name?: string
  type?: string
  typeline?: string[]
  level?: number
  attribute?: string
  atk?: number
  def?: number
}

const CATEGORY_RANK: Record<DeckCardCategory, number> = {
  monster: 0,
  spell: 1,
  trap: 2,
  other: 3,
}

export function deckCardCategory(card: SortableDeckCard): DeckCardCategory {
  if (Array.isArray(card.typeline)) {
    if (card.typeline.includes('Monster')) return 'monster'
    if (card.typeline.includes('Spell')) return 'spell'
    if (card.typeline.includes('Trap')) return 'trap'
  }
  if (typeof card.type === 'string') {
    const type = card.type.toLowerCase()
    if (type.includes('monster')) return 'monster'
    if (type.includes('spell')) return 'spell'
    if (type.includes('trap')) return 'trap'
  }
  return 'other'
}

/**
 * Monsters by level, then attribute, ATK, DEF and name.
 * Spells, then traps, each by name. Copies of one card stay together.
 */
export function compareDeckOrder(a: SortableDeckCard, b: SortableDeckCard): number {
  const category = CATEGORY_RANK[deckCardCategory(a)] - CATEGORY_RANK[deckCardCategory(b)]
  if (category !== 0) return category
  if (deckCardCategory(a) === 'monster') {
    const level = (b.level || 0) - (a.level || 0)
    if (level !== 0) return level
    const attribute = (a.attribute || '').localeCompare(b.attribute || '')
    if (attribute !== 0) return attribute
    const atk = (b.atk || 0) - (a.atk || 0)
    if (atk !== 0) return atk
    const def = (b.def || 0) - (a.def || 0)
    if (def !== 0) return def
  }
  return (a.name || '').localeCompare(b.name || '')
}

export function sortDeckCards<T extends SortableDeckCard>(cards: readonly T[]): T[] {
  return [...cards].sort(compareDeckOrder)
}
